import React from "react";
import s from "./style.module.scss";
import { StarRatingValue } from "../StarRatingValue";
import { ApprovedIcon } from "../Icons/Approved";
import glideImage from "../../utils/useGlideImage.ts";

type TestimonialCardSmallProps = {
  img: string;
  name: string;
  tr_title: string;
  tr_text: string;
  tr_days_ago: string;
  verifiedBuyer: string;
  stars_rating: string;
};

export const TestimonialCardSmall = ({
  card,
  verifiedBuyer,
}: {
  card: TestimonialCardSmallProps;
  verifiedBuyer: string;
}) => {
  return (
    <div className={s.testimonialCardSmall}>
      <div className={s.testimonialCardSmall__top}>
        <img
          src={glideImage(card.img, { w: 44, h: 44 })}
          alt={card.name}
          width={44}
          height={44}
          loading="lazy"
        />
        <p className={s.testimonialCardSmall__name}>{card.name}</p>

        <div className={s.testimonialCardSmall__stars}>
          <StarRatingValue rating={card.stars_rating || "4.5"} />
        </div>

        <div className={s.testimonialCardSmall__verified}>
          <ApprovedIcon />
          <p dangerouslySetInnerHTML={{ __html: verifiedBuyer }} />
        </div>
        <p className={s.testimonialCardSmall__daysAgo}>{card.tr_days_ago}</p>
      </div>

      <div>
        <p className={s.testimonialCardSmall__title}>{card.tr_title}</p>
        <p
          className={s.testimonialCardSmall__text}
          dangerouslySetInnerHTML={{ __html: card.tr_text }}
        />
      </div>
    </div>
  );
};
